import { useState } from 'react'

import { CustomSelect, type OptionItem } from '@wartek-id/select'
import { Text } from '@wartek-id/text-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import { FILTER_STATE } from 'app/KinerjaTimPenilaiPenilikPage/utils/status'
import TablePerencanaanPenilik from 'app/KinerjaTimPenilaiPenilikPage/components/TablePerencanaanPenilik'
import usePerencanaanList from 'app/KinerjaTimPenilaiPenilikPage/hooks/usePerencanaanList'
import useBasePath from 'app/KinerjaTimPenilaiPenilikPage/hooks/useBasePath'

import type {
  PerencanaanFilterState,
  PerencanaanSummary,
} from 'types/kinerja-tim-penilai-penilik'

const mapping: Record<
  Exclude<
    PerencanaanFilterState,
    | 'BELUM_DIAJUKAN_PENILIK'
    | 'DAPAT_DISETUJUI_SEKALIGUS'
    | 'DISETUJUI_PEJABAT_PENILAI_KINERJA'
  >,
  keyof PerencanaanSummary
> = {
  ALL: 'total',
  SUDAH_DIAJUKAN_PENILIK: 'sudahDiajukanPenilik',
  BELUM_DISETUJUI_PEJABAT_PENILAI_KINERJA:
    'belumDisetujuiPejabatPenilaiKinerja',
  DIARAHKAN_REVISI_OLEH_TIM_KINERJA: 'diarahkanRevisiOlehTimKinerja',
  DIARAHKAN_REVISI_OLEH_PEJABAT_PENILAI_KINERJA:
    'diarahkanRevisiOlehPejabatPenilaiKinerja',
}

export default function TimPenilaiDaftarPenilikPage() {
  const [activeFilterState, setActiveFilterState] =
    useState<PerencanaanFilterState>('ALL')

  const { basePath, isPPKPenilikUrl: isPPKPenilik } = useBasePath()
  const { data, summary, isLoading, isFetched } = usePerencanaanList({
    filter: activeFilterState,
  })

  return (
    <div className="px-24 py-6 m-auto max-w-7xl">
      <Header title="Daftar Perencanaan Kinerja" className="mt-6" />
      <div className="mt-12 bg-white border rounded border-gray-30">
        <div className="p-6 pb-0 space-y-1">
          <Text variant="heading-md" as="h2">
            Periksa Perencanaan Penilik
          </Text>
          <Text color="subdued">
            {isPPKPenilik
              ? 'Anda dapat setujui Perencanaan atau arahkan Penilik untuk revisi.'
              : 'Anda dapat berikan rekomendasi persetujuan ke Pejabat Penilai Kinerja atau arahkan Penilik untuk revisi.'}
          </Text>
        </div>

        <div className="flex p-6">
          {isFetched && (
            <CustomSelect
              className="w-[650px]"
              value={{
                name: `${FILTER_STATE[activeFilterState]} (${
                  summary?.[
                    mapping[activeFilterState as keyof typeof mapping]
                  ] ?? 0
                })`,
                value: activeFilterState,
              }}
              onChange={(e: OptionItem) =>
                setActiveFilterState(e.value as PerencanaanFilterState)
              }
              options={
                Object.keys(mapping).map((state) => ({
                  name: `${FILTER_STATE[state]} (${
                    summary?.[mapping[state as keyof typeof mapping]] ?? 0
                  })`,
                  value: state as PerencanaanFilterState,
                })) as OptionItem[]
              }
              placeholder="Pilih di sini"
            />
          )}
        </div>

        <TablePerencanaanPenilik
          basePath={basePath}
          data={data?.data ?? []}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
